var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"dense":"","outlined":"","disabled":!_vm.editing || _vm.readonly,"error-messages":_vm.isValidContent,"label":_vm.$messages.serialNum.serialNumber.token.types.fixed.content},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }